module.exports = __webpack_public_path__ + "img/repair-crane.1d54eac2.webp";